<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class SimpleTourBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest
        @Prop({default: () => {}}) product

        get items() {
            const cityLabel = simpleTourRuntimeStore.city?.id
                ? `${simpleTourRuntimeStore.city.name}, ${simpleTourRuntimeStore.city.countryName}`
                : ''
            const name = useRoute().name
            const items = [this.homeItem]
            const addSearchPageLink = items => {
                    items.push({
                        title: cityLabel,
                        to: simpleTourRuntimeStore.searchPageLink(this.searchRequest),
                        exact: true,
                    })
                },
                addInfoPageLink = items => {
                    items.push({
                        title: this.product?.name,
                        to: simpleTourRuntimeStore.infoPageLink(this.product, this.searchRequest),
                        exact: true,
                    })
                }
            switch (name) {
                case 'simpleTourSearch':
                    items.push({
                        title: cityLabel,
                        to: simpleTourRuntimeStore.searchPageLink(this.searchRequest),
                        disabled: true,
                        exact: true,
                    })
                    break
                case 'simpleTour':
                    addSearchPageLink(items)
                    items.push({
                        title: this.product.info?.name,
                        disabled: true,
                    })
                    break
                case 'simpleTourBooking':
                    addSearchPageLink(items)
                    addInfoPageLink(items)
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'simpleTourConfirmation':
                    addSearchPageLink(items)
                    items.push({
                        title: this.product.info?.name,
                        disabled: true,
                    })
                    items.push({
                        title: this.$t('confirmation'),
                        disabled: true,
                    })
                    break
            }
            return items
        }
    }

    export default {...toNative(SimpleTourBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
